/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import Layout from 'components/common/Layout';
import UserInfo from 'components/user/mypage/UserInfo';
import MypageSelect from 'components/user/mypage/MypageSelect';
import MymallData from 'components/user/mypage/mymall/MymallData';

const Mymall = () => {
  return (
    <Layout theme="white">
      <UserInfo />
      <MypageSelect active="mymall" />
      <MymallData />
    </Layout>
  );
};

export default Mymall;
